import styled from 'styled-components';
import { FunctionColor, BrandColor } from '@lux/text';

export const Wrapper = styled.div`
    font-weight: 700;
    font-family: sans-serif;
    font-size: 1.6rem;
`;

export const CounterContainerSt = styled.div`
    display: flex;
    justify-content: center;
    bottom: 35px;
    left: 53px;
`;

export const FlipSt = styled.div`
    color: ${FunctionColor.function0};
    line-height: 28px;
    vertical-align: center;
    text-align: center;
    width: 20px;
    height: 26px;
    margin: 0 1px;
    background-color: #4f4f4f;

    &:before {
        position: absolute;
        content: '';
        height: 1px;
        width: 18px;
        margin-top: 13px;
        margin-left: -4px;
        background-color: #4f4f4f;
    }
`;

export const Separator = styled.div`
    text-align: center;
    width: 8px;
    margin: 0 1px;
`;

export const Last = styled.div`
    color: ${BrandColor.primary};
`;

export const LabelsContainer = styled.div`
    bottom: 15px;
    display: flex;
    justify-content: center;
    margin-top: 5px;
    font-size: 10px;
    font-weight: 400;
`;

export const Label = styled.div`
    text-align: center;
    min-width: 44px;
`;
